export default "__VITE_ASSET__C2h6DN9v__"